import { ISearchApi } from "@api/affair.int";
import { IUserPub } from "@api/auth.int";
import { IAffairSearchResult, ISearchHit } from "@api/txt.int";
import { Box, Icon, Input, InputGroup, InputRightElement, Text } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { AFFAIR_KINDS, GUARD_KINDS } from "components/appComponents";
import { HitBogyo, HitBox, HitLineMain, HitLineSub, HitNotFound, HitRight, HL, PaginatorBox, usePaginator } from "components/paginator";
import { formatDate, formatDateTime, useDebounce } from "components/utils";
import { VizvCard, VizvCardHeaderPopup, VizvMainCol } from "components/vizvComponents";
import { useEffect, useRef, useState } from "react";
import { MdSearch } from "react-icons/md";
import { Outlet, useNavigate, useParams } from "react-router";


export function converResult(res: IAffairSearchResult) {
    const res2 = {
        ...res,
        items: res.matchList
    };
    return res2;
}
export type TPage = ReturnType<typeof converResult>;

export function VVSearchMain() {
    const routeParams = useParams();
    const nav = useNavigate();
    const api = useVVApi();

    const routeQ = routeParams["q"];
    const [inputQ, setInputQ] = useState(routeQ || '');
    const debouncedInputQ = useDebounce(inputQ.replace(/\s+/g, " ").trim(), 500);


    const inputRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        inputRef.current?.focus({preventScroll:true});

    }, []);

    const isDetailed = !!routeParams.affairKey || !!routeParams.userKey;
    const navRoot = '/search/' + encodeURIComponent(debouncedInputQ);

    useEffect(() => {
        nav(navRoot)
    }, [navRoot]);

    const pager = usePaginator({
        parse: (res: IAffairSearchResult) => ({ items: res.matchList, nextKeys: res.nextKeys }),
        deps: [routeQ],
        loadNext: async (nextKeys?: string) => {
            if (routeQ) {
                const resp = await api.fetch<ISearchApi>({ url: '/affair/search', method: 'GET', query: { q: routeQ || '', ...nextKeys && { fromKeys: nextKeys } } });
                if (resp.result.matchList.length === 0)
                    resp.result.msg = "Nincs találat."
                return resp.result;
            } else {
                return Promise.resolve({
                    nextKeys: undefined,
                    msg: 'Kezdj el írni!',
                    unusedWords: [],
                    matchList: [], //todo
                });
            }
        }
    });

    return <>
        <VizvMainCol isTool={{ width: 400, isDetailed }} mapNavRoot={navRoot} >
            <VizvCard isTool
                isClosable
                mr={5} mt={5}
                maxHeight="calc(100vh - 4em)"
            >
                <VizvCardHeaderPopup fontSize='x-large' fontWeight='400' variant="blue" mb={2}  >
                    Keresés
                </VizvCardHeaderPopup>
                <Box p={2}>
                    <Box>
                        <InputGroup>
                            <Input ref={inputRef} value={inputQ} onChange={e => setInputQ(e.target.value)} placeholder="Keresés" />
                            <InputRightElement><Icon as={MdSearch} /></InputRightElement>
                        </InputGroup>
                    </Box>
                </Box>

                {pager.page?.msg && <Box px={2} color='#fff8'>
                    {pager.page?.msg}
                </Box>}
                {(pager.page?.unusedWords || []).length > 0 /*&& pgResult.matchList.length == 0*/ && <Box px={2}>
                    {pager.page?.unusedWords.map((w, wix) => <Text key={wix} textDecor='line-through' textColor='#0ab7ffba'>{w}</Text>)}
                </Box>}

                <PaginatorBox pager={pager} item={hit => <HitBox
                    //key={hix}
                    hit={{ affair: hit.item.affair, user: hit.item.user }}
                    highlight={[...hit.withAccent, ...hit.woAccent]}
                >
                    <HitBogyo />
                    <HitRight>
                        {hit.item.affair && <>
                            <HitLineSub><HL text={hit.item.affair.userRef.userName} />&nbsp;/&nbsp;{formatDateTime(hit.item.createdAt)}</HitLineSub>
                            <HitLineMain><HL text={hit.item.affair.affairTitle} /></HitLineMain>
                            <HitLineSub><HL text={AFFAIR_KINDS[hit.item.affair.affairKind].name} /></HitLineSub>
                        </>}
                        {hit.item.user && <>
                            <HitLineSub>
                                {formatDate(hit.item.user.createdAt)}
                            </HitLineSub>
                            <HitLineMain><HL text={hit.item.user.guard?.name || hit.item.user.userName} /></HitLineMain>
                            <HitLineSub>
                                {hit.item.user.guard ? GUARD_KINDS[hit.item.user.guard.kind].name : 'Felhasználó'}
                                {hit.item.user.userSummary.jelentettCount > 0 && <>, {hit.item.user.userSummary.jelentettCount} bejelentés</>}
                            </HitLineSub>
                            {hit.item.user.guard && <HitLineSub>{hit.item.user.guard.locationTitle}</HitLineSub>}
                        </>}
                        <HitNotFound words={hit.notFound} />
                    </HitRight>
                </HitBox>
                } />
            </VizvCard>
        </VizvMainCol>
        <Outlet />
    </>


}



